<template>
  <div :class="wrapperClasses">
    <v-icon
      v-if="!isMensagemDoAtendente"
      small
      :class="iconClasses"
    >
      {{ mensagemIcon }}
    </v-icon>

    <span
      class="email-content-viewer"
      v-html="conteudoTexto"
    />

    <v-icon
      v-if="isMensagemDoAtendente"
      small
      :class="iconClasses"
    >
      {{ mensagemIcon }}
    </v-icon>
  </div>
</template>

<script>
import { computed } from '@vue/composition-api'

export default {
  props: {
    conteudoTexto: {
      type: String,
      required: true,
    },
    mensagemIcon: {
      type: String,
      default: null,
    },
    isMensagemDoAtendente: {
      type: Boolean,
      required: true,
    },
    podeResponderMensagem: {
      type: Boolean,
      required: true,
    },
    ticketEstaFinalizado: {
      type: Boolean,
      required: true,
    },
  },

  setup(props) {
    const wrapperClasses = computed(() => `
      d-flex align-center
      ${props.podeResponderMensagem && !props.ticketEstaFinalizado ? 'mr-4' : ''}
    `)
    const iconClasses = computed(() => (props.isMensagemDoAtendente ? 'white--text ml-2' : ' mr-2'))

    return {
      wrapperClasses,
      iconClasses,
    }
  },
}
</script>

<style scoped>
.email-content-viewer {
  white-space: pre-line;
}
</style>
